

import {Request} from '@/api/request';
import {
    defineComponent,
    ref,
    reactive,
    inject,
    provide,
    onMounted,
    watch, nextTick,
} from "vue";
import {
    getCheckOutMountingsInfo,
    getInfoOrderOffer,
    getLibraryInfo, getMaterialInfo, getMountingsCheckOutInfo,
    getOrderCarMountings,
    getOrderCarProject,
    postAddOrderOffer
} from "@/api/http";
import { Debounce } from "@/api/api";
import {dateformat} from "@/api/date" ;
import {column} from "@/assets/types/common";
import editList from "@/components/editlist/editlist.vue";
import {useRoute, useRouter} from 'vue-router'
import {validateInput, validateClass} from "@/assets/js/formRules";

type project = {
    id: number;
    project_type_pid: number;
    name: string;
};
type dialogSelect = {
    project_type_pid?: number;
    search?: string;
};
type order = {
    basicset_id: number;
    id: number;
    user_id: number;
    coupon_text: string;
    pay_type: number;
    payment: number;
    order: any;
    order_car: any;
    order_message: any;
    offer: any;
    last_order_id: string;
    next_order_id: string
};
const carcodeColumn: Array<column> = [
    {
        prop: "ordersn",
        label: "单据编号",
        width: 84,
    },
    {
        prop: "car_code",
        label: "车牌号",
        width: 84,
    },
    
    {
        prop: "category_name",
        label: "车辆型号",
        width: 84,
    },
    {
        prop: "meet_vehicle",
        label: "接车人",
        width: 84,
    },
    {
        prop: "create_time_text",
        label: "开单时间",
        width: 84,
    },
];
const partsColumn: Array<column> = [
    {
        prop: "name",
        label: "配件名称",
        width: 84,
    },
    
    {
        prop: "specification",
        label: "规格",
        width: 84,
    },
    {
        prop: "mountings_type_name",
        label: "配件分类",
        width: 84,
    },
    {
        prop: "mountings_brand_name",
        label: "品牌",
        width: 84,
    },
    {
        prop: "mountings_unit_name",
        label: "单位",
        width: 84,
    },
    {
        prop: "price",
        label: "价格",
        width: 84,
    },
    {
        prop: "stock",
        label: "库存",
        width: 84,
    },
];
const detailColumn: Array<column> = [
    {
        prop: "name",
        label: "配件名称",
        width: 84,
    },
    {
        prop: "mountings_name",
        label: "编码",
        width: 84,
    },
    
    {
        prop: "specification",
        label: "规格",
        width: 84,
    },
    {
        prop: "mountings_type_name",
        label: "分类",
        width: 84,
    },
    {
        prop: "mountings_brand_name",
        label: "品牌",
        width: 84,
    },
    {
        prop: "mountings_unit_name",
        label: "品牌",
        width: 84,
    },
    {
        prop: "price",
        label: "单位",
        width: 84,
    },
    {
        prop: "stock",
        label: "报价数量",
        width: 84,
    },
    {
        prop: "stock",
        label: "用料数量",
        width: 84,
    },
    {
        prop: "stock",
        label: "领料",
        width: 84,
    },
    {
        prop: "stock",
        label: "退料",
        width: 84,
    },
];

const coloumList = [
    [
        {
            type: 'lable',
            field: 'name',
            label: '配件名称',
            title: '',
            img: {
                src: '',
                width: 0,
                height: 0
            },
            width: 450,
            ewidth: '',
            estyle: '',
            eclass: ''
        },
        {
            type: 'lable',
            field: 'mountings_type_p_name',
            label: '配件分类',
            title: '',
            img: {
                src: '',
                width: 0,
                height: 0
            },
            width: 120,
            ewidth: '',
            estyle: '',
            eclass: ''
        },
        {
            type: 'lable',
            field: 'mountings_unit_name',
            label: '单位',
            title: '',
            img: {
                src: '',
                width: 0,
                height: 0
            },
            width: 120,
            ewidth: '',
            estyle: '',
            eclass: ''
        },
        {
            type: 'lable',
            field: 'cost_price',
            label: '采购单价',
            title: '',
            img: {
                src: '',
                width: 0,
                height: 0
            },
            width: 120,
            ewidth: '',
            estyle: '',
            eclass: ''
        },
        {
            type: 'lable',
            field: 'member',
            label: '数量',
            title: '',
            img: {
                src: '',
                width: 0,
                height: 0
            },
            width: '',
            ewidth: '',
            estyle: '',
            eclass: ''
        },
        {
            type: 'lable',
            field: 'stock_number_',
            label: '已入库',
            title: '',
            img: {
                src: '',
                width: 0,
                height: 0
            },
            width: 125,
            ewidth: '',
            estyle: '',
            eclass: ''
        },
        {
            type: 'lable',
            field: 'stay_number',
            label: '待入库',
            title: '',
            img: {
                src: '',
                width: 0,
                height: 0
            },
            width: 125,
            ewidth: '',
            estyle: '',
            eclass: ''
        },
        {
            type: 'input',
            field: 'stock_number',
            label: '退料',
            title: '',
            img: {
                src: '',
                width: 0,
                height: 0
            },
            width: 125,
            ewidth: 80,
            estyle: '',
            eclass: ''
        },
        {
            type: 'lable',
            field: 'return_number',
            label: '退货数量',
            title: '',
            img: {
                src: '',
                width: 0,
                height: 0
            },
            width: 125,
            ewidth: 80,
            estyle: '',
            eclass: ''
        },
    ],
    [
        {
            type: 'button',
            field: 'name',
            label: '配件名称',
            title: '',
            img: {
                src: '',
                width: 0,
                height: 0
            },
            width: 450,
            ewidth: 355,
            estyle: '',
            eclass: ''
        },
        {
            type: 'specification',
            field: 'mountings_type_p_name',
            label: '编码',
            title: '',
            img: {
                src: '',
                width: 0,
                height: 0
            },
            width: 120,
            ewidth: '',
            estyle: '',
            eclass: ''
        },
        {
            type: 'lable',
            field: 'mountings_type_pname',
            label: '规格',
            title: '',
            img: {
                src: '',
                width: 0,
                height: 0
            },
            width: 120,
            ewidth: '',
            estyle: '',
            eclass: ''
        },
        {
            type: '分类',
            field: 'mountings_type_pname',
            label: '采购单价',
            title: '',
            img: {
                src: '',
                width: 0,
                height: 0
            },
            width: 120,
            ewidth: '',
            estyle: '',
            eclass: ''
        },
        {
            type: 'lable',
            field: 'mountings_brand_name',
            label: '品牌',
            title: '',
            img: {
                src: '',
                width: 0,
                height: 0
            },
            width: '',
            ewidth: '',
            estyle: '',
            eclass: ''
        },
        {
            type: 'lable',
            field: 'unit',
            label: '单位',
            title: '',
            img: {
                src: '',
                width: 0,
                height: 0
            },
            width: 125,
            ewidth: '',
            estyle: '',
            eclass: ''
        },
        {
            type: 'lable',
            field: 'number',
            label: '退料',
            title: '',
            img: {
                src: '',
                width: 0,
                height: 0
            },
            width: 125,
            ewidth: 80,
            estyle: '',
            eclass: ''
        },
    ]

]
const return_cash_plan = {
    return_cash_plan: [
        {
            required: true,
            validator: (rule: any, value: string, callback: Function) => {
                if (value) {
                    callback();
                } else {
                    callback(new Error("请选择返现方案"));
                }
            },
            trigger: "blur",
        },
    ],
};
const partsRules = {
    name: [
        {
            required: true,
            validator: (rule: any, value: string, callback: Function) => {
                validateInput("请输入配件名称", value, callback);
            },
            trigger: "change",
        },
    ],
    price: [
        {
            required: true,
            validator: (rule: any, value: string, callback: Function) => {
                validateInput("请输入销售价", value, callback);
            },
            trigger: "change",
        },
    ],
    specification: [
        {
            required: true,
            validator: (rule: any, value: string, callback: Function) => {
                validateInput("请输入规格", value, callback);
            },
            trigger: "change",
        },
    ],
    encoding: [
        {
            required: true,
            validator: (rule: any, value: string, callback: Function) => {
                validateInput("请输入编码", value, callback);
            },
            trigger: "change",
        },
    ],
    unit_id: [
        {
            required: true,
            validator: (rule: any, value: string, callback: Function) => {
                if (value) {
                    callback();
                } else {
                    callback(new Error("请选择单位"));
                }
            },
            trigger: "blur",
        },
    ],
    ...return_cash_plan,
};

const formRules = {
    type: [{required: true, message: '必填', trigger: 'change'}],
    supplier_id: [{required: true, message: '必填', trigger: 'change'}],
    date: [{required: true, message: '必填', trigger: 'change'}],
}


export default defineComponent({
    name: "createInBill",
    components: {editList},
    setup() {
        const setTitle: any = inject("setTitle");
        const headClass = inject("headClass");
        const Router = useRouter();
        let searchKeyWords = ref(''),
            //配件搜索
            searchMountings = new Debounce().use(() => {
                if (form.value.type == 0) {
                    //退料入库
                    getCheckOutMountingsInfo({order_id: form.value['car_order_id'],search: searchKeyWords.value}).then((res: any) => {
                        if (res.status == 200) {
                            partsTable.value = res.content.list;
                        }
                    });
                } else if (form.value.type == 1) {
                    //辅料领料入库
                    getMaterialInfo({record_code: form.value['ordersn'],search: searchKeyWords.value}).then((res: any) => {
                        if (res.status == 200) {
                            partsTable.value = res.content.list;
                        }
                    });
                } else {
                    getOrderCarMountings({search: searchKeyWords.value}).then((res: any) => {
                        partsTable.value = res?.content?.mountings_data?.list || [];
                    });
                }
            },500);
        let uid: any = 0,
            inputref = ref(null) as any,
            type: any = '',
            offer_data = ref([]) as any,
            dialog_show = reactive({
                parts: false,
                carcode: false
            } as any),
            is_save = ref(false),
            dialog_show_ = ref(""),
            dialogNavIndex = ref(0),
            dialog_search = ref('' as string),
            dialog_isload = ref(false),
            dialog_data = ref([] as Array<any>),
            detailData = reactive([1, 2, 4, 5, 6] as Array<any>),
            serviceForm = ref({
                name: "",
                price: null,
                return_cash_plan: null,
            }),
            partsForm = ref({
                ...serviceForm.value,
                encoding: null,
                specification: "",
                unit_id: null,
            }),
            is_detail = ref(false),
            partsFormNode = ref(null),
            partsTable = ref([] as any),
            dialogSelect = ref({} as dialogSelect),
            serviceTable = ref([]),
            form = ref({
                type: 0,
                takeaway: null,
                car_order_id: null,
                car_name: null,
                parts: [],
                branch_id: null,
                ordersn: null,
                desc: ""
            } as any),
            is_all = ref(false),
            serviceDialog = ref(false),
            supplierList = ref([] as any),
            orderDetail = ref({offer: [[], []]} as order),
            selectData: Array<project> = [],
            selectList = reactive({
                staff: [],
                branch: [],
                mountings_type_data: [],
                mountings_type_p_data: []
            }),
            is_load = ref(false),
            formRef = ref(null),
            PurchaseManList = ref([] as any),
            getOrderMountings = (): void => {
                getOrderCarMountings(dialogSelect.value).then((res: any) => {
                    
                    // partsTable.value = res?.content?.mountings_data?.list || [];
                    // select.mountings_type_data = res?.content?.mountings_type || [];
                    // select.mountings_type_p_data =  res?.content?.mountings_type_p || [];
                });
            },
            handleSelectionChange = (selection: Array<project>): void => {
                selectData = selection;
            },
            //选中配件列表的一条数据
            handleCurrentChange = (selection: any): void => {
                if (!selection) return
                for (const parts of form.value.parts) {
                    if (parts.mountings_id == selection.id) {
                        alert("您选择的配件已经在列表中了，请直接改数量");
                        return;
                    }
                }
                form.value.parts.push({
                    mountings_type_id: selection.id,
                    mountings_id: selection.id,
                    name: selection.name,
                    specification: selection.specification,
                    mountings_type_pname: selection.mountings_type_name,
                    mountings_brand_name: selection.mountings_brand_name,
                    unit: selection.mountings_unit_name,
                    unit_price: selection.price,
                    number: '0'
                })
                dialog_show_.value = ''
                
            },
            dialogSelectChange = (
                value: string | number,
                key: keyof dialogSelect
            ): void => {
                if (!value) {
                    delete dialogSelect.value[key];
                }
                if (serviceDialog.value) {
                    getOrderProject();
                } else {
                    getOrderMountings();
                }
            },
            getOrderProject = (): void => {
                getOrderCarProject(dialogSelect.value).then((res: any) => {
                    // serviceTable.value = res?.content?.project?.list || [];
                    // select.project_type_data =
                    //     res?.content?.project_type?.list || [];
                });
            },
            checkFormData = (): boolean => {
                
                if (form.value.type == 0) {
                    if (!form.value.takeaway) {
                        alert('请选择退料人');
                        return false;
                    }
                    if (!form.value.car_name) {
                        alert('请选择维修车辆')
                        return false;
                    }
                    if (!form.value.branch_id) {
                        alert('请选择成本承担部门')
                        return false;
                    }
                } else if (form.value.type == 1) {
                    if (form.value.type == 1) {
                        if (!form.value.takeaway) {
                            alert('请选择退料人');
                            return false;
                        }
                        if (!form.value.ordersn) {
                            alert('请选择辅料出库单')
                            return false;
                        }
                        if (!form.value.branch_id) {
                            alert('请选择成本承担部门')
                            return false;
                        }
                    }
                }
                if (form.value.parts.length == 0) {
                    alert('请添加配件')
                    return false;
                } else {
                    for (const parts of form.value.parts) {
                        if (parts.number <= 0) {
                            alert('请输入数量')
                            return false;
                        }
                    }
                }
                return true
            },
            _onsubmit = () => {
                if (!checkFormData()) {
                    return;
                }
                is_load.value = true;
                let url = '';
                let myData = {};
                myData = form.value;
    
                if (is_save.value) {//useRoute().query.uid
                    //入库单修改
                    url = 'adminapi/Warehouse/editCheckInBill';
                    myData = {...form.value, id: uid}
                } else {
                    //入库单新增
                    url = 'adminapi/Warehouse/CreateWarehousing';
                    myData = form.value;
                }
                
                
                Request.axiosInstance({
                    url: url,
                    data: myData
                }).then((res: any) => {
                    is_load.value = false
                    res.status == 202 && Router.go(-1)
                })
            },
            _editlist_add = () => {
                //入库单不能直接加配件
                
                if (form.value.type == 0 && !form.value.car_name) {
                    alert('请选择维修车辆')
                    return
                }
                if (form.value.type == 1 && !form.value.ordersn) {
                    alert('请选择辅料出库单')
                    return
                }
                
                
                dialog_show_.value = 'parts'
                
            },
            getSummaries = (param: any) => {
            },
            //车牌号码搜索和单据搜索
            get_dialog_data = () => {
                
                dialog_isload.value = true
                if (dialog_show_.value == 'carcode') {
                    Request.axiosInstance({
                        url: 'adminapi/OrderCar/carcodeGetList',
                        data: {car_code: dialog_search.value}
                    }).then((res: any) => {
                        dialog_isload.value = false
                        dialog_data.value = res?.content?.list || []
                    })
                } else {
                    Request.axiosInstance({
                        url: 'adminapi/Warehouse/libraryList',
                        data: {type: 1, status: 1, search: dialog_search.value, library_type: '1'}
                    }).then((res: any) => {
                        dialog_isload.value = false
                        dialog_data.value = res?.content?.list || []
                    })
                }
                
                
            },
            //选中车牌
            _table_select_carcode = (selection: any) => {
                if (!selection) return
                if (dialog_show_.value == 'carcode') {
                    form.value['car_order_id'] = selection.id;
                    form.value['car_name'] = selection.car_code;
                    form.value['ordersn'] = selection.ordersn;
                    //选完车牌之后要自动添加关联车辆报价配件供选择，去配件报价那里也就是orderoffer表拿，已出库和未出库的都显示出来，
                    // 然后在去出入库记录表查询该订单已出库的配件
                    //入库是点添加的时候显示相应的配件
                } else if (dialog_show_.value == 'warehousing') {
                    form.value['ordersn'] = selection.record_code
                }
                
                dialog_show_.value = ''
            },
            getdetail = (id: number) => {
                //门店ID【当为总店时必传】
                let userinfo;
                let user_info = localStorage.getItem('user_info');
                if (user_info) {
                    userinfo = JSON.parse(user_info);
                }
                let data = {};
                if (userinfo.store_id == 0) {
                    data = {
                        store_id: 'store_id',
                        id
                    }
                } else {
                    data = {
                        id
                    }
                }
                getLibraryInfo(data).then((res: any) => {
                    if (res.status == 200) {
                        form.value.branch_id = res.content.info.branch_id;
                        form.value.takeaway = res.content.info.takeaway;
                        form.value.desc = res.content.info.desc;
                        form.value.type = res.content.info.type;
                        form.value.parts = res.content.info.parts_list;
                        form.value.car_order_id = res.content.info.car_order_id;
                        form.value.ordersn = res.content.info.ordersn;
                        form.value.car_name = res.content.info.car_name;
                        
                    }
                });
            },
            _defItem = (index: number) => {
                if (!confirm('是否确认操作？')) return
                form.value.parts.splice(index, 1)
            }
        
        
        watch(dialog_show_, (newdata: any, olddata: any) => {
            console.log(newdata)
            if (newdata == 'carcode' || newdata == 'warehousing') {
                dialog_search.value = "";
                nextTick(() => {
                    inputref.value.focus();
                });
                get_dialog_data();
            } else if (newdata == 'parts') {
                //入库单选择维修车辆后点击添加出现该车辆的领料出库配件
                if (form.value.type == 0) {
                    getCheckOutMountingsInfo({order_id: form.value['car_order_id']}).then((res: any) => {
                        if (res.status == 200) {
                            partsTable.value = res.content.list;
                        }
                    });
                } else if (form.value.type == 1) {
                    getMaterialInfo({record_code: form.value['ordersn']}).then((res: any) => {
                        if (res.status == 200) {
                            partsTable.value = res.content.list;
                        }
                    });
                } else {
                    getOrderCarMountings(dialogSelect.value).then((res: any) => {
                        partsTable.value = res?.content?.mountings_data?.list || [];
                        selectList.mountings_type_data = res?.content?.mountings_type || [];
                        selectList.mountings_type_p_data = res?.content?.mountings_type_p || [];
                    });
                }
            }
            
            
        });
        
        onMounted(() => {
            
            let title = ''
            is_load.value = true
            
            title = "入库单";
            
            setTitle(["仓库管理", title]);
            
            
            Request.axiosInstance({
                url: 'adminapi/OrderCar/constructors'
            }).then((res: any) => {
                selectList.staff = res?.content?.staff || []
                selectList.branch = res?.content?.branch || []
                is_load.value = false
            });
            let id: any = useRoute().query.uid;
            uid = useRoute().query.uid;
            if (id) {
                getdetail(id);
                is_save.value = true;
            }
            
            //getOrderMountings()
        });
        
        
        return {
            dialog_show,
            dialogNavIndex,
            partsRules,
            partsForm,
            partsFormNode,
            partsTable,
            dialogSelect,
            serviceForm,
            selectList,
            headClass,
            is_all,
            handleSelectionChange,
            handleCurrentChange,
            partsColumn,
            dialogSelectChange,
            getOrderProject,
            getOrderCarProject,
            serviceDialog,
            orderDetail,
            selectData,
            serviceTable,
            form,
            PurchaseManList,
            supplierList,
            is_load,
            _onsubmit,
            formRef,
            formRules,
            _editlist_add,
            type,
            carcodeColumn,
            is_detail,
            detailColumn,
            getSummaries,
            detailData,
            dialog_isload,
            dialog_data,
            dialog_search,
            get_dialog_data,
            _table_select_carcode,
            dialog_show_,
            _defItem,
            coloumList,
            searchMountings,
            searchKeyWords,
            inputref,
            offer_data
        };
    },
});
